import { getApiActionResult, fetchGet, fetchPost, getBase64FromFile, getApiFileResult } from "src/~api/ApiHelper";
import { IApiActionResult } from "src/~api/ApiActionResult";
import { IChannel } from "src/app/channel/~store/models/Channel";
import { GET_ENABLED_CHANNELS_API_ROUTE, SAVE_MAILING_API_ROUTE, GET_MAILING_BY_ID_API_ROUTE, GET_MAILINGS_LAZY_API_ROUTE, START_MAILING_API_ROUTE, DELETE_MAILING_API_ROUTE, GET_MAILING_RECIPIENT_API_ROUTE, GET_USED_MAILINGS_CHATS_API_ROUTE, STOP_MAILING_API_ROUTE } from "./apiRoutes";
import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";
import { IMailing } from "../~store/models/mailing";
import { IMailingRecipient } from "../~store/models/mailing-recipient";
import { MailingStatus } from "../~store/models/enums/MailingStatus";
import { SearchRecipientsType } from "../~store/models/enums/SearchRecipientsType";
import { MailingType } from "../~store/models/enums/MailingType";
import { IBotStartParams } from "../~store/models/BotStartParams";
import { toApiSearchingTags } from "src/app/shared/helpers/api-body-helper/searchInputHelper";

export const getEnabledChannelsAsync = async (): Promise<IApiActionResult<IChannel[]>> => {
    const fetchPromise = fetchGet(GET_ENABLED_CHANNELS_API_ROUTE);
    return await getApiActionResult(fetchPromise, true);
};

export const saveMailingAsync = async (mailing: IMailing): Promise<IApiActionResult<void>> => {

    if (mailing.mailingType === MailingType.message) {
        mailing.botStartParams = {} as IBotStartParams;

        if (mailing.text) {
            mailing.text = mailing.text.trim();
        }
        if (mailing.image != null) 
            mailing.base64Picture = await getBase64FromFile(mailing.image);
    } else {
        mailing.text = mailing.buttonText = mailing.buttonUrl = mailing.pictureId = "";
    }

    if (mailing.searchRecipientsType) {
        mailing.recipientFilter = {
            recipientFilter: mailing.searchRecipientsType,
            searchingTags: (mailing.searchRecipientsType === SearchRecipientsType.inChats ? mailing.searchingTagsForChats : mailing.searchingTagsForContacts) ?? []
        };
    }
    
    mailing.status = MailingStatus.pending;

    const { allBots, ...mailingWithoutBots } = mailing;

    const fetchPromise = fetchPost(SAVE_MAILING_API_ROUTE, {
        body: JSON.stringify({
            mailingModel: {
                ...mailingWithoutBots,
                recipientFilter: {
                    ...mailing.recipientFilter,
                    searchingTags: toApiSearchingTags(mailing.recipientFilter?.searchingTags ?? [])
                },
                searchingTagsForChats: [],
                searchingTagsForContacts: [],
                pictureFileName: mailing.image?.name ?? null,
                pictureMimeType: mailing.image?.type ?? null
            },
        })
    });
    return await getApiActionResult(fetchPromise, false);
};

export const getRecipientsAsync = async (mailingId: number, skip: number, count: number): Promise<IApiActionResult<IMailingRecipient[]>> => {
    const fetchPromise = fetchGet(GET_MAILING_RECIPIENT_API_ROUTE + `?mailingId=${mailingId}&skip=${skip}&count=${count}`);
    return await getApiActionResult(fetchPromise, true);
};

export const getMailingByIdAsync = async (mailingId: number): Promise<IApiActionResult<IMailing>> => {
    const fetchPromise = fetchGet(GET_MAILING_BY_ID_API_ROUTE + mailingId);
    return await getApiActionResult(fetchPromise, true);
};

export const getMailingsAsync = async (skip: number, count: number): Promise<IApiActionResult<IMailing[]>> => {
    const fetchPromise = fetchGet(GET_MAILINGS_LAZY_API_ROUTE + `?skip=${skip}&count=${count}`);
    return await getApiActionResult(fetchPromise, true);
};

export const startMailingAsync = async (mailingId: number): Promise<IApiActionResult<IMailing>> => {
    const fetchPromise = fetchGet(START_MAILING_API_ROUTE + mailingId);
    return await getApiActionResult(fetchPromise, true);
};

export const deleteMailingAsync = async (mailingId: number): Promise<IApiActionResult<void>> => {
    const fetchPromise = fetchGet(DELETE_MAILING_API_ROUTE + mailingId);
    return await getApiActionResult(fetchPromise, false);
};

export const getUsedMailingsCountAsync = async (): Promise<IApiActionResult<number>> => {
    const fetchPromise = fetchGet(GET_USED_MAILINGS_CHATS_API_ROUTE);
    return await getApiActionResult(fetchPromise, true);
}

export const getImageAsBlobAsync = async (pictureId: string): Promise<IApiActionResult<Blob>> => {
    const fetchPromise = fetchGet(GET_FILE_BY_ID_API_ROUTE + pictureId);
    return await getApiFileResult(fetchPromise);
};

export const stopMailingAsync = async (mailingId: number): Promise<IApiActionResult<IMailing>> => {
    const fetchPromise = fetchGet(STOP_MAILING_API_ROUTE + mailingId);
    return await getApiActionResult(fetchPromise, true);
};